import type { FC } from "react";

import Image from "next/image";

import { Logo as LogoUI } from "@jti/ui/eva-components/Logo";

import { usePageConfig } from "@/context/PageConfigContext";

import type { logoInputs } from "./inputs/logoInputs.builder";

export type LogoProps = BuilderComponentProps<typeof logoInputs> & {
  priority?: boolean;
};

export const Logo: FC<LogoProps> = (props) => {
  const { darkMode } = usePageConfig();

  const { link, title, srcDark, srcLight, alt, priority } = props;

  return (
    <LogoUI
      isDarkMode={darkMode}
      link={link}
      title={title}
      srcDark={srcDark}
      srcLight={srcLight}
      alt={alt}
      renderImage={({ src, alt }) => <Image src={src} alt={alt} layout="fill" priority={priority} />}
    />
  );
};

export default Logo;
